import { useEffect, useRef, useState } from "react";
import { Box, Text, VStack } from "@chakra-ui/react";
import { Cartographic, Math as CesiumMath, Cartesian2, ScreenSpaceEventType } from "cesium";
import { computeZoomLevel } from "../utilies/MapUtility";
import { useAppStore } from "../context/store";

function MapInfo() {
  const showMapInfo = useAppStore((s) => s.showMapInfo);
  const viewerRef = useAppStore((s) => s.viewerRef);

  const [zoom, setZoom] = useState("-");
  const [latLng, setLatLng] = useState("-, -");
  const lastMouseWinRef = useRef(null);

  useEffect(() => {
    let rafId = null;
    let viewer = null;
    let disposed = false;
    let onPostRender = null;

    const initWhenReady = () => {
      if (disposed) return;
      if (!viewerRef?.current) {
        rafId = requestAnimationFrame(initWhenReady);
        return;
      }

      viewer = viewerRef.current;
      const camera = viewer.camera;
      const scene = viewer.scene;
      const canvas = viewer.canvas;

      const updateMouseLatLng = () => {
        const win = lastMouseWinRef.current;
        if (!win) return;
        const cart = camera.pickEllipsoid(win, scene.globe.ellipsoid);
        if (!cart) return;
        const carto = Cartographic.fromCartesian(cart);
        const lat = CesiumMath.toDegrees(carto.latitude).toFixed(7);
        const lon = CesiumMath.toDegrees(carto.longitude).toFixed(7);
        setLatLng(`${lat}, ${lon}`);
      };

      onPostRender = () => {
        const z = computeZoomLevel(viewer);
        setZoom(z.toFixed(2));
        updateMouseLatLng();
      };

      viewer.screenSpaceEventHandler.setInputAction((movement) => {
        lastMouseWinRef.current = movement.endPosition || movement.position;
      }, ScreenSpaceEventType.MOUSE_MOVE);

      scene.postRender.addEventListener(onPostRender);
      lastMouseWinRef.current = new Cartesian2((canvas.clientWidth || canvas.width) / 2, (canvas.clientHeight || canvas.height) / 2);
      onPostRender();
    };

    initWhenReady();

    return () => {
      disposed = true;
      if (rafId) cancelAnimationFrame(rafId);
      try {
        viewer?.scene?.postRender?.removeEventListener(onPostRender);
      } catch {}
    };
  }, [viewerRef]);

  if (!showMapInfo) return null;

  return (
    <Box position="absolute" bg="white" bottom="35px" right="20px" p={2} borderRadius="lg" shadow="md">
      <VStack gap={0} align="start">
        <Text fontSize="14px">Zoom Level: {zoom}</Text>
        <Text fontSize="14px">Lat, Lon: {latLng}</Text>
      </VStack>
    </Box>
  );
}

export default MapInfo;
